import { Component } from "vue-property-decorator"

import GroupBySortByBase from "./groupBySortBy.client.base"

@Component
export default class GroupBySortByWeb extends GroupBySortByBase {}
